import { DialogContent, IconButton, List, ListItem, ListItemText } from "@mui/material";
import { Company } from "models/Company";
import Clear from "@mui/icons-material/Clear";
import { useGetUsersQuery, useRemoveUserFromCompanyMutation } from "app/api/companies";
import EmptyMessage from "components/EmptyMessage";
import AddUserForm from "../components/AddUserForm";

type UsersSectionProps = { company: Company };

const UsersSection: React.FC<UsersSectionProps> = (props) => {
  const { company } = props;

  const { data: users } = useGetUsersQuery({ companyId: company.id });

  const [removeUserFromCompany, { isLoading: isRemovingUser }] = useRemoveUserFromCompanyMutation();

  return (
    <>
      <DialogContent sx={{ p: 1 }}>
        <List disablePadding>
          {!users?.length && (
            <ListItem divider>
              <ListItemText primary={<EmptyMessage>Inga användare hittades</EmptyMessage>} />
            </ListItem>
          )}
          {users?.map((user) => (
            <ListItem
              key={user.id}
              divider
              secondaryAction={
                <IconButton
                  loading={isRemovingUser}
                  onClick={() => removeUserFromCompany({ companyId: company.id, userId: user.id })}
                >
                  <Clear />
                </IconButton>
              }
            >
              <ListItemText
                primary={user.userName}
                secondary={user.email}
                slotProps={{ primary: { fontWeight: "bold" } }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      <AddUserForm company={company} />
    </>
  );
};

export default UsersSection;
